export const LEGAL_USER_TYPE = 'legal';
export const DATA_ATTRIBUTE_FOR_USER_INFO = 'data-user-settings';
